import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class CityService {
  constructor(private readonly apiService: ApiService) {}

  getAll() {
    return this.apiService.get<any[]>('city');
  }

  getById(id: number | string) {
    return this.apiService.get<any[]>(`city/${id}`);
  }

  update(data: any) {
    return this.apiService.put<any[]>(`city/update`);
  }

  delete(id: number | string) {
    return this.apiService.delete(`city/delete/${id}`);
  }

  getCitiesByCountryId(countryId:number){
    return this.apiService.get<any[]>(`city/citiesByCountryId/${countryId}`);
  }
}
